/* Este contexto guarda token e info de usuario, maneja expiración y logout.
Todo lo que necesitas para que cualquier componente pueda acceder al token y usuario actual. */
import React, { createContext, useContext, useState, useEffect } from "react";

const UsuarioEmpresaContext = createContext();

const safeParse = (value) => {
  try {
    return value ? JSON.parse(value) : null;
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return null;
  }
};

export const ProtectedRoute = ({ children }) => {
  const [Token, setToken] = useState(localStorage.getItem("Token") || null);
  const [Usuario, setUsuario] = useState(
    safeParse(localStorage.getItem("Usuario"))
  );
  
  // Guardar token con expiración relativa
  const setAdminUserEmpresaToken = (token, expiresInMinutes = 60) => {
    if (token) {
      const expiry =
        new Date().getTime() + expiresInMinutes * 60 * 1000; // ahora + 30 min
      localStorage.setItem("Token", token);
      localStorage.setItem("TokenExpiry", expiry);
      setToken(token);
    } else {
      localStorage.removeItem("Token");
      localStorage.removeItem("TokenExpiry");
      setToken(null);
    }
  };

  const setUserInformationUsuario = (data) => {
    setUsuario(data);
    if (data) {
      localStorage.setItem("Usuario", JSON.stringify(data));
    } else {
      localStorage.removeItem("Usuario");
    }
  };

  const logout = () => {
     const hadToken = !!localStorage.getItem("Token");
    localStorage.removeItem("Token");
    localStorage.removeItem("TokenExpiry");
    localStorage.removeItem("Usuario");

    setToken(null);
    setUsuario(null);

    if (hadToken && window.location.pathname !== "/") {
    window.location.href = "/";
  }
  };

  // ✅ Validar expiración al montar
  useEffect(() => {
    const storedToken = localStorage.getItem("Token");
    const expiry = localStorage.getItem("TokenExpiry");
    const storedUsuario = localStorage.getItem("Usuario");

    if (storedToken && expiry && new Date().getTime() < Number(expiry)) {
      setToken(storedToken);
      setUsuario(safeParse(storedUsuario));
    } else {
      logout(); // ya expiró
    }
  }, []);
  

  // ✅ Revisar expiración cada minuto
 useEffect(() => {
  const interval = setInterval(() => {
    const expiry = localStorage.getItem("TokenExpiry");
    if (expiry && new Date().getTime() >= Number(expiry)) {
      
      logout(); // rompe token
    } 
  }, 60 * 1000);

  return () => clearInterval(interval);
}, []);

  // ✅ Resetear el timer en cada actividad
  useEffect(() => {
    const resetExpiry = () => {
      if (Token) {
        const newExpiry = new Date().getTime() + 60 * 60 * 1000;
        localStorage.setItem("TokenExpiry", newExpiry);
      
      }
    };

    const events = ["mousemove", "mousedown", "keypress", "scroll", "touchstart"];
    events.forEach((event) => window.addEventListener(event, resetExpiry));

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetExpiry));
    };
  }, [Token]);

  return (
    <UsuarioEmpresaContext.Provider
      value={{
        Token,
        Usuario,
        setAdminUserEmpresaToken,
        setUserInformationUsuario,
        logout,
      }}
    >
      {children}
    </UsuarioEmpresaContext.Provider>
  );
};

export const useUserSuperEmpresa = () => useContext(UsuarioEmpresaContext);


